import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LeafletGeoJsonLayerComponent } from './leaflet-geo-json-layer.component';



@NgModule({
  declarations: [
    LeafletGeoJsonLayerComponent
  ],
	exports: [
		LeafletGeoJsonLayerComponent
	],
  imports: [
    CommonModule
  ]
})
export class LeafletGeoJsonLayerModule { }
